export const convertTitleToDataTestId = (title: string) => {
  return title.replace(/\s/g, "-");
};
